import { cards } from '@/mocks/baoliao';

const cardImages: Record<string, string> = {
  'card-01': 'https://readdy.ai/api/search-image?query=Financial%20fraud%20investigation%20concept%20with%20documents%20and%20stamp%20seals%20on%20dark%20desk%2C%20warm%20crimson%20and%20gold%20tones%2C%20abstract%20corporate%20scandal%20style%2C%20dramatic%20overhead%20lighting%2C%20editorial%20business%20expose%20aesthetic%2C%20mysterious%20atmosphere&width=700&height=460&seq=card-01&orientation=landscape',
  'card-02': 'https://readdy.ai/api/search-image?query=Celebrity%20secret%20marriage%20scandal%20concept%20with%20wedding%20ring%20and%20blurred%20paparazzi%20photos%2C%20warm%20amber%20and%20dark%20rose%20tones%2C%20abstract%20entertainment%20news%20style%2C%20dramatic%20soft%20focus%2C%20editorial%20gossip%20magazine%20aesthetic&width=700&height=460&seq=card-02&orientation=landscape',
  'card-03': 'https://readdy.ai/api/search-image?query=Food%20delivery%20worker%20on%20scooter%20in%20rain%20at%20night%20with%20city%20lights%2C%20warm%20orange%20and%20dark%20blue%20tones%2C%20cinematic%20street%20photography%20style%2C%20social%20issue%20documentary%20aesthetic%2C%20moody%20urban%20atmosphere%2C%20compelling%20composition&width=700&height=460&seq=card-03&orientation=landscape',
  'card-04': 'https://readdy.ai/api/search-image?query=Stock%20market%20crash%20concept%20with%20falling%20candlestick%20charts%20and%20red%20warning%20indicators%2C%20warm%20crimson%20and%20dark%20charcoal%20tones%2C%20abstract%20financial%20crisis%20style%2C%20dramatic%20market%20panic%20aesthetic%2C%20editorial%20investment%20expose&width=700&height=460&seq=card-04&orientation=landscape',
  'card-05': 'https://readdy.ai/api/search-image?query=Talent%20show%20voting%20manipulation%20concept%20with%20stage%20lights%20and%20torn%20scorecards%2C%20warm%20gold%20and%20dark%20theater%20tones%2C%20abstract%20reality%20TV%20scandal%20style%2C%20dramatic%20behind%20the%20scenes%20aesthetic%2C%20editorial%20entertainment%20expose&width=700&height=460&seq=card-05&orientation=landscape',
  'card-06': 'https://readdy.ai/api/search-image?query=Gym%20fitness%20center%20closed%20with%20chains%20and%20padlock%20on%20door%2C%20abandoned%20equipment%20visible%20through%20glass%2C%20warm%20amber%20and%20dark%20tones%2C%20documentary%20photography%20style%2C%20consumer%20protection%20aesthetic&width=700&height=460&seq=card-06&orientation=landscape',
  'card-07': 'https://readdy.ai/api/search-image?query=Examination%20papers%20and%20answer%20sheets%20scattered%20on%20desk%20with%20red%20pen%20markings%2C%20warm%20terracotta%20and%20cream%20tones%2C%20abstract%20education%20controversy%20style%2C%20dramatic%20whistleblower%20aesthetic%2C%20editorial%20investigation%20composition&width=700&height=460&seq=card-07&orientation=landscape',
};

export default function InfoCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            深度爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精选深度调查报道，还原事件完整真相
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 6).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer hover:border-primary-200 transition-all"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={cardImages[item.imageSeq]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                  {item.category}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-medium text-foreground-900 text-sm md:text-base group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-3 mb-3">
                  {item.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500 pt-3 border-t border-background-200/50">
                  <span>{item.time}</span>
                  <span className="w-1 h-1 rounded-full bg-background-400"></span>
                  <span>{item.reads} 阅读</span>
                </div>
              </div>
            </div>
          ))}

          <div className="md:col-span-2 lg:col-span-3">
            <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer hover:border-primary-200 transition-all">
              <div className="flex flex-col md:flex-row">
                <div className="md:w-2/5 relative overflow-hidden">
                  <img
                    src={cardImages['card-07']}
                    alt={cards[6].title}
                    className="w-full h-48 md:h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {cards[6].category}
                  </span>
                </div>
                <div className="md:w-3/5 p-5 md:p-6 flex flex-col justify-center">
                  <h3 className="font-medium text-foreground-900 text-base md:text-lg group-hover:text-primary-600 transition-colors mb-2">
                    {cards[6].title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed line-clamp-4 mb-3">
                    {cards[6].summary}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500 pt-3 border-t border-background-200/50">
                    <span>{cards[6].time}</span>
                    <span className="w-1 h-1 rounded-full bg-background-400"></span>
                    <span>{cards[6].reads} 阅读</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}